// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Es6Promise from "es6-promise";

import axios from "axios";
import VueAxios from "vue-axios";
import VueFullpage from "vue-fullpage.js"; //首页幻灯片

import global_ from "./assets/api"; // 本地测试 正式
import MetaInfo from "vue-meta-info"; //seo 优化

import vueSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

Vue.use(vueSwiper);

Vue.prototype.global = global_; // 本地测试 正式
Vue.use(ElementUI);
Es6Promise.polyfill();
Vue.use(VueAxios, axios);

Vue.use(VueFullpage); //首页幻灯片

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: {
    App
  },
  template: "<App/>",
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  }
});



// WEBPACK FOOTER //
// ./src/main.js